// initial state
// shape: [{ id, quantity }]
const state = {}

// getters
const getters = {
  // demoTable: state => state.table
}

// actions
const actions = {
  getFairPrizeTable ({commit, state}, params) {
    let promised = request.alert('getFairPrizeTable', params)
    return promised
  },
  deleteFairPrize ({commit, state}, id) {
    let promised = request.alert('deleteFairPrize', id)
    return promised
  },
  createFairPrize ({commit, state}, params) {
    let promised = request.alert('createFairPrize', params)
    return promised
  },
  editFairPrize ({commit, state}, params) {
    let promised = request.alert('editFairPrize', params)
    return promised
  },
  getFairPrizeDetail ({commit, state}, id) {
    let promised = request.alert('getFairPrizeDetail', id)
    return promised
  },
  getFairPrizeOptions ({commit, state}) {
    let promised = request.alert('getFairPrizeOptions')
    return promised
  },
  uploadFairPrizeImg ({commit, state}, params) {
    let promised = request.alert('uploadFairPrizeImg', params)
    return promised
  },
  getFairPrizeLogList ({commit, state}, params) {
    let promised = request.alert('getFairPrizeLogList', params)
    return promised
  },
}

// mutations
const mutations = {}

export const fairPrize = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/fair-prize/fairPrize.store.js